/* eslint-disable @typescript-eslint/ban-ts-comment */
import { shouldPolyfill } from '@formatjs/intl-pluralrules/should-polyfill';

export async function intlPluralrulesPolyfill() {
  if (shouldPolyfill()) {
    await import('@formatjs/intl-pluralrules/polyfill');
  }

  // @ts-ignore
  if (Intl.PluralRules.polyfilled) {
    // @ts-ignore
    await import('@formatjs/intl-pluralrules/locale-data/en');
  }
}
